/// <reference path="../../../../typings/index.d.ts" />

module Meevo.Plugins.CancellationReasons {
    angular.module("meevo.plugins.cancellationReasons", []);
}